namespace GeniuzPOS.Inventory {
    export interface IcStockTransferDtRow {
        Id?: number;
        SysDocNo?: string;
        LineItemNo?: number;
        SkuCode?: string;
        SupplItemCode?: string;
        ItemRemark?: string;
        Qty?: number;
        UnitCost?: number;
        UnitChange?: UnitChangeEnumFg;
        PurUnit?: string;
        PurUnitRatio?: number;
        PurUnitPrice?: number;
        CostValue?: number;
        ExpDate?: string;
        Remark?: string;
    }

    export namespace IcStockTransferDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockTransferDt';
        export const deletePermission = '2Inventory:รายการ:โอนระหว่างคลัง:Modify';
        export const insertPermission = '2Inventory:รายการ:โอนระหว่างคลัง:Modify';
        export const readPermission = '2Inventory:รายการ:โอนระหว่างคลัง:View';
        export const updatePermission = '2Inventory:รายการ:โอนระหว่างคลัง:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            SupplItemCode = "SupplItemCode",
            ItemRemark = "ItemRemark",
            Qty = "Qty",
            UnitCost = "UnitCost",
            UnitChange = "UnitChange",
            PurUnit = "PurUnit",
            PurUnitRatio = "PurUnitRatio",
            PurUnitPrice = "PurUnitPrice",
            CostValue = "CostValue",
            ExpDate = "ExpDate",
            Remark = "Remark"
        }
    }
}
